import classnames from "classnames";
import PropTypes from "prop-types";
import { Heading, Text } from "../Typography";
import "./faq-item.scss";

const FaqItem = ({ title, description, className }) => {
  return (
    <details className={classnames("bwl-faq-item", className)}>
      <summary className="bwl-faq-item__summary">
        <Heading variant="h4" className="bwl-faq-item__title">
          {title}
        </Heading>
        <span className="bwl-faq-item__chevron" aria-hidden="true">
          ▾
        </span>
      </summary>
      <Text variant="paragraph" className="bwl-faq-item__description">
        {description}
      </Text>
    </details>
  );
};

FaqItem.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default FaqItem;
